import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { PontoCriticoAcaoSituacaoService } from "../services/ponto-critico-acao-situacao.service";

@Injectable({
  providedIn: 'root'
})
export class PontosCriticosAcaoSituacaoInitValuesResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getInitValues(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontosCriticosAcaoSituacaoEntregaInitValuesResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getEntregaInitValues(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontosCriticosAcaoSituacaoIndicadorInitValuesResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getIndicadorInitValues(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontosCriticosAcaoSituacaoAgregadorIndicadorInitValuesResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getAgregadorIndicadorInitValues(route.params.idAcao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoAcaoSituacaoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.idSituacao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoEntregaAcaoSituacaoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdEntrega(route.params.idSituacao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoIndicadorAcaoSituacaoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdIndicador(route.params.idSituacao);
  }
}

@Injectable({
  providedIn: 'root'
})
export class PontoCriticoAgregadorIndicadorAcaoSituacaoResolver implements Resolve<boolean> {

  constructor(private service: PontoCriticoAcaoSituacaoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getByIdAgregadorIndicador(route.params.idSituacao);
  }
}